import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getUsers = ({
  churchId,
  isDenomination = false,
  denominationId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/users`
  );
};

export const useUsers = ({
  churchId,
  isDenomination = false,
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["users", isDenomination ? denominationId : churchId],
    queryFn: () => getUsers({ churchId, isDenomination, denominationId })
  });
};
